// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__31f8E","tab":"Tabs_tab__lsW31","tabActive":"Tabs_tabActive__2P7nO"};